import React from 'react';
import { compose } from 'ramda';

import styleFile from './buttonSubmit.js';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withTheme } from '@synergycms_core/components/providers/themeProvider';
import { withForm } from './';
import Button from '@synergycms_core/components/generic/Button';

export default compose(
  withForm(),
  PropertyManager(['form', 'config', 'onClick', 'text', 'richText', 'icon', 'disableOnError']),
  withTheme(styleFile)
)(
  class ButtonOverride extends React.Component {
    static displayName = 'ButtonOverride';
    render = () => {
      const { config } = this.props;
      const { form } = config;
      const disableOnError = config.disableOnError && !form.validForm;
      return <Button {...config} disabled={form.requestInProgress || disableOnError} onClick={form.onOverrideValues} />;
    };
  }
);
